import React from 'react'
import { BooleanIcon } from '@/common/components/BooleanIcon.tsx'
import dayjs from 'dayjs'
import { Descriptions } from 'antd'
import { Checklist } from '@/common/types/checklist.def.ts'
import { EmployeeTooltip } from '@/common/components/EmployeeTooltip.tsx'
import { ChecklistCustomFieldMapping } from '@/features/checklist/checklist.def.ts'

type ChecklistDescriptionsProps = {
  data: Checklist
}

export const ChecklistDescriptions: React.FC<ChecklistDescriptionsProps> = ({ data }) => {
  const items = [
    { label: 'Country', children: data.country },
    { label: 'Employment Entity', children: data.employmentEntity },
    { label: 'Category', children: data.category },
    ...(data.configName ? [{ label: 'Config Name', children: data.configName }] : []),
    {
      label: 'Is Complete',
      children: <BooleanIcon value={data.isComplete} />,
    },
    {
      label: 'Created At',
      children: dayjs(data.createdAt).format('YYYY-MM-DD'),
    },
    {
      label: 'Updated At',
      children: dayjs(data.updatedAt).format('YYYY-MM-DD'),
    },
    {
      label: 'Employee Name',
      children: data.employeeId ? <EmployeeTooltip employeeId={data.employeeId} /> : data.employeeName,
    },
  ]

  const extraItems = data.extraDetails.map(detail => ({
    label: detail.fieldName,
    children: ChecklistCustomFieldMapping[detail.fieldName]?.type === 'employeeSearch'
      ? <EmployeeTooltip employeeId={detail.value} labelFn={x => `${x.displayName} (${x.employeeId})`} />
      : detail.value,
  }))

  return <Descriptions column={2} items={[...items, ...extraItems]} />
}